export const AccentHeadline = ({ text, accent }) => {
  const i = accent ? text.lastIndexOf(accent) : -1;
  if (i < 0) return text;
  return (
    <>
      {text.slice(0, i)}
      <em className="accent-italic text-gradient" data-testid="headline-accent">
        {accent}
      </em>
      {text.slice(i + accent.length)}
    </>
  );
};
